var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "addressManage"
  }, [_c('Header'), _c('div', {
    staticClass: "m_content usercont content"
  }, [_c('NavMenu'), _c('div', {
    staticClass: "menucont"
  }, [_c('div', {
    staticClass: "right_top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("收货地址")]), _c('div', {
    staticClass: "add",
    on: {
      "click": _vm.openAdd
    }
  }, [_c('i', {
    staticClass: "iconfont el-icon-plus"
  }), _vm._v(" 新建地址 ")])]), _c('div', [_vm.isNodata ? _c('div', {
    staticClass: "norecord"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/no_record.png")
    }
  }), _c('span', [_vm._v("暂无数据")])]) : _vm._e(), _c('ul', _vm._l(_vm.addressList, function (item) {
    return _c('li', {
      key: item.id,
      on: {
        "click": function click($event) {
          return _vm.selectAddress(item);
        }
      }
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', [_c('span', [_vm._v("收货人：")]), _vm._v(" " + _vm._s(item.realName) + " ")]), _c('div', [_c('span', [_vm._v("联系方式：")]), _vm._v(" " + _vm._s(item.telephone) + " ")]), _c('div', [_c('span', [_vm._v("收货地址：")]), _vm._v(" " + _vm._s(item.address) + " ")])]), _c('div', {
      staticClass: "btn_box"
    }, [_c('i', {
      staticClass: "iconfont iconbianji1",
      on: {
        "click": function click($event) {
          return _vm.openEdit(item);
        }
      }
    }), _c('i', {
      staticClass: "iconfont iconshanchulanse",
      on: {
        "click": function click($event) {
          return _vm.openDelete(item.id);
        }
      }
    }), _c('span', {
      staticClass: "default",
      class: item.defaultAddress === 1 ? 'active' : '',
      on: {
        "click": function click($event) {
          return _vm.updateDefaultData(item);
        }
      }
    }, [_vm._v(_vm._s(item.defaultAddress === 1 ? '默认地址' : '设为默认地址'))])])]);
  }), 0)])])], 1), _c('Footer'), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "close-on-click-modal": false,
      "visible": _vm.showDialogBack,
      "title": _vm.textMap[_vm.dialogStatus],
      "width": "500px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showDialogBack = $event;
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "modal-append-to-body": false,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    staticClass: "version",
    attrs: {
      "label": "姓名",
      "prop": "realName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "请输入姓名",
      "autocomplete": "off"
    },
    model: {
      value: _vm.ruleForm.realName,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "realName", $$v);
      },
      expression: "ruleForm.realName"
    }
  })], 1), _c('el-form-item', {
    staticClass: "version",
    attrs: {
      "label": "手机号码"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "20",
      "placeholder": "请输入手机号码",
      "autocomplete": "off"
    },
    model: {
      value: _vm.ruleForm.telephone,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "telephone", _vm._n($$v));
      },
      expression: "ruleForm.telephone"
    }
  })], 1), _c('el-form-item', {
    staticClass: "version",
    attrs: {
      "label": "地址",
      "prop": "areaId"
    }
  }, [_c('div', {
    staticClass: "linkage"
  }, [_c('el-select', {
    staticClass: "addressselect",
    attrs: {
      "placeholder": "省级地区"
    },
    on: {
      "change": _vm.chooseProvince
    },
    model: {
      value: _vm.ruleForm.provinceId,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "provinceId", $$v);
      },
      expression: "ruleForm.provinceId"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1), _c('el-select', {
    staticClass: "addressselect",
    attrs: {
      "placeholder": "市级地区"
    },
    on: {
      "change": _vm.chooseCity
    },
    model: {
      value: _vm.ruleForm.cityId,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "cityId", $$v);
      },
      expression: "ruleForm.cityId"
    }
  }, _vm._l(_vm.cityOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1), _c('el-select', {
    staticClass: "addressselect",
    attrs: {
      "placeholder": "区级地区"
    },
    on: {
      "change": _vm.chooseArea
    },
    model: {
      value: _vm.ruleForm.areaId,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "areaId", $$v);
      },
      expression: "ruleForm.areaId"
    }
  }, _vm._l(_vm.areaOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1)]), _c('el-form-item', {
    staticClass: "version",
    attrs: {
      "label": "详细地址",
      "prop": "addressTemp"
    }
  }, [_c('div', {
    staticClass: "remarks"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入内容",
      "maxlength": "50"
    },
    model: {
      value: _vm.ruleForm.addressTemp,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "addressTemp", $$v);
      },
      expression: "ruleForm.addressTemp"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.ruleForm.addressTemp.length) + "/50")])], 1)]), _c('el-form-item', {
    staticClass: "version",
    attrs: {
      "label": "设为默认地址"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0,
      "active-color": "#0043ff",
      "inactive-color": "#ddd"
    },
    model: {
      value: _vm.ruleForm.defaultAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.ruleForm, "defaultAddress", $$v);
      },
      expression: "ruleForm.defaultAddress"
    }
  })], 1), _c('el-form-item', [_c('div', {
    staticClass: "dialogfooter"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        _vm.showDialogBack = false;
      }
    }
  }, [_vm._v("取消")]), _c('span', {
    on: {
      "click": function click($event) {
        _vm.dialogStatus === 'create' ? _vm.createData() : _vm.updateData();
      }
    }
  }, [_vm._v("确定")])])])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };